import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import { ServiceValues } from '../../values/ServiceValues';
import { ServiceAxios } from '../../services/ServiceEW';
import PacoteTable from './components/PacoteTable';
import PacoteToolbar from './components/PacoteToolbar/PacoteToolbar';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import ProgressFullScreen from '../../components/Compartilhados/ProgressFullScreen';
import SnackbarCustom from '../../components/Compartilhados/Snackbar';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import Typography from '@material-ui/core/Typography';
import { NotFound as NotFoundView } from '../index';
import { MessageValues } from '../../values/MessageValues';
import { isAuthenticated } from '../../helpers/authenticate';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3)
  },
  content: {
    marginTop: theme.spacing(2)
  },
  pagination: {
    marginTop: theme.spacing(3),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end'
  },
  divFab:{
    zIndex: 2
  },
  fab: {
    position: 'fixed',
    bottom: theme.spacing(2),
    right: theme.spacing(2),
  },
}));
function PacoteList({history}) {
  const timeout = ServiceValues.timeout;
  const baseUrl = ServiceValues.base_url_local;
  const api = ServiceAxios(baseUrl, timeout);
  const classes = useStyles();
  const [loading, setLoading] = React.useState(false);
  const [pacotes, setPacotes] = useState({
    result: []
  });
  const [showMessageSnack, setShowMessageSnack] = useState(false);
  const [messageSnack, setMessageSnack] = useState('');
  const [typeSnack, setTypeSnack] = useState('success');
  const [showDialogConfirmacaoDeletePacote, setShowDialogConfirmacaoDeletePacote] = useState(false);
  const [selectedIndexPacote, setSelectedIndexPacote] = useState(-1);
  const [cnpjConfirmation, setCnpjConfirmation] = useState('');
  const [sucess, setSucess] = useState(true);
  const [openPacoteChangePassword, setOpenPacoteChangePassword] = useState(false);
  const [pacoteSelecionado, setPacoteSelecionado] = useState({});

  useEffect(() => {
    function checkAuth() {
      isAuthenticated(history);
    }
    checkAuth();
  }, []);

  useEffect(() => {
    async function carregarPacotes() {
      try{
        setLoading(true);
        const params = {
          limit: 100,
        };
        const dados = await api.get('pacotes/', {params: params});
        setLoading(false);
        if(dados.data.isSuccess){
          if(dados.data.result.length !== 0){
            for(let i = 0, size = dados.data.result.length; i < size; i++){
              dados.data.result[i].on_mouse_over = false;
            }
            setPacotes(dados.data);
          }
          else{
            setLoading(false);
            setTypeSnack('warning');
            setMessageSnack('Não há pacotes cadastradas');
            setShowMessageSnack(true);
          }
        }
        else{
          setSucess(false);
        }

      }
      catch (e) {
        setSucess(false);

      }
    }
    carregarPacotes();
  }, []);

  function showConfirmationDeletePacote(index){
    if (selectedIndexPacote < 0 && selectedIndexPacote >= pacotes.result.length) {
      setLoading(false);
      setTypeSnack('error');
      setMessageSnack('Não foi possível deletar o usuário');
      setShowMessageSnack(true);
    }
    else{
      setSelectedIndexPacote(index);
      setShowDialogConfirmacaoDeletePacote(true);
    }

  }

  async function deletePacote() {
    if (selectedIndexPacote < 0 && selectedIndexPacote >= pacotes.result.length) {
      setLoading(false);
      setTypeSnack('error');
      setMessageSnack('Não foi possível deletar o pacote');
      setShowMessageSnack(true);
    }
    else{
      try {
        setShowDialogConfirmacaoDeletePacote(false);
        setLoading(true);
        const id = pacotes.result[selectedIndexPacote].idPacote;
        const dados = await api.delete(`pacotes/${id}`);
        setCnpjConfirmation('');
        if (dados.data.isSuccess === true) {
          const params = {
            limit: 100,
          };
          const dados = await api.get('pacotes/', { params: params });
          setLoading(false);
          if (dados.data.isSuccess === true) {
            setTypeSnack('success');
            setMessageSnack('Pacote deletado com sucesso');
            setShowMessageSnack(true);
            for (let i = 0, size = dados.data.result.length; i < size; i++) {
              dados.data.result[i].on_mouse_over = false;
            }
            setPacotes(dados.data);
          } else {
            setTypeSnack('error');
            setMessageSnack('Erro ao carregar pacotes');
            setShowMessageSnack(true);
          }
        } else {
          setTypeSnack('error');
          setMessageSnack('Erro ao deletar pacote. Contate o suporte.');
          setShowMessageSnack(true);
        }

      } catch (e) {
        setCnpjConfirmation('');
        setLoading(false);
        setTypeSnack('error');
        setMessageSnack(MessageValues.erro_catch + ' Detalhamento erro: ' + e.toString());
        setShowMessageSnack(true);
      }

    }
  }

  function onCancelDeletePacote() {
    setSelectedIndexPacote(-1);
    setShowDialogConfirmacaoDeletePacote(false)
  }

  async function filterPacotes(filterValue) {
    try {
      setLoading(true);
      const params = {
        descricao: filterValue
      };
      const dados = await api.get('pacotes/filter', { params: params });
      setLoading(false);
      if (dados.data.isSuccess) {
        for (let i = 0, size = dados.data.result.length; i < size; i++) {
          dados.data.result[i].on_mouse_over = false;
        }
        setPacotes(dados.data);
      } else {
      }

    } catch (e) {
      console.log(e.toString())
    }
  }

  function openPacoteRegister() {
    const pacote = {
      descricao: '',
      valor: 0,
      acrescimosCartao: false,
      valorVendaCartao: 0,
      quantidadeDisparos: 0,
      armas: []
    };
    history.push('/pacote-register/', {pacote: pacote, edicao: false});
  }

  async function openPacoteEdit(index) {
    try{
      if (index < 0 && index >= pacotes.result.length) {
        setLoading(false);
        setTypeSnack('error');
        setMessageSnack('Não foi possível editar a pacote');
        setShowMessageSnack(true);
      } else {
        setLoading(true);
        const dados = await api.get(`pacotes/${pacotes.result[index].idPacote}`);
        setLoading(false);
        if(dados.data.isSuccess){
          if(dados.data.result.length > 0){
            history.push('/pacote-edit/', {pacote: dados.data.result[0], edicao: true});
          }
          else{
            setLoading(false);
            setTypeSnack('error');
            setMessageSnack('Ocorreu um erro ao obter dados da pacote.');
            setShowMessageSnack(true);
          }
        }
        else{
          setLoading(false);
          setTypeSnack('error');
          setMessageSnack('Ocorreu um erro ao obter dados da pacote.');
          setShowMessageSnack(true);
        }
      }
    }
    catch (e) {
      setSucess(false);
    }
  }

  return (
    sucess
    ?
      <div
        className={classes.root}
      >
        <PacoteToolbar
          filterPacotes={filterPacotes}
        />
        <SnackbarCustom
          verticalOrientation='bottom'
          horizontalOrientation='center'
          open={showMessageSnack}
          setOpen={setShowMessageSnack}
          message={messageSnack}
          duration={2000}
          type={typeSnack}
        />
        <Dialog open={showDialogConfirmacaoDeletePacote} aria-labelledby="form-dialog-title">
          <DialogTitle id="form-dialog-title">Remoção de pacote</DialogTitle>
          <DialogContent>
            <Typography gutterBottom>
              Você está tentando deletar o pacote com as seguintes informações:
            </Typography>
            <Typography
              gutterBottom
              style={{marginTop: '30px'}}
            >
              {selectedIndexPacote < 0 || selectedIndexPacote >= pacotes.result.length ? '' :
                'Descricao: ' + pacotes.result[selectedIndexPacote].descricao
              }
            </Typography>
            <Typography
              gutterBottom
            >
              {selectedIndexPacote < 0 || selectedIndexPacote >= pacotes.result.length ? '' :
                'Quantidade de disparos: ' + pacotes.result[selectedIndexPacote].quantidadeDisparos
              }
            </Typography>
            <Typography gutterBottom style={{marginTop: '30px'}}>
              Tem certeza que deseja excluir esse pacote?
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={onCancelDeletePacote} color="primary">
              Cancelar
            </Button>
            <Button onClick={deletePacote} color="primary">
              Confirmar
            </Button>
          </DialogActions>
        </Dialog>
        <div className={classes.content}>
          <ProgressFullScreen
            open={loading}
            setOpen={setLoading}
          />
          <PacoteTable
            pacotes={pacotes}
            setPacotes={setPacotes}
            deletePacote={showConfirmationDeletePacote}
            editPacote={openPacoteEdit}
            showMessageSnack={showMessageSnack}
            setShowMessageSnack={setShowMessageSnack}
            messageSnack={messageSnack}
            setMessageSnack={setMessageSnack}
            typeSnack={typeSnack}
            setTypeSnack={setTypeSnack}
          />
        </div>
        <div
          className={classes.divFab}

        >
          <Fab
            aria-label={'Add'}
            className={classes.fab}
            color={'primary'}
            variant={'round'}
            onClick={openPacoteRegister}
          >
            <AddIcon />
          </Fab>
        </div>
      </div>
      :
      <NotFoundView/>

  );
};

export default PacoteList;
